/**
 * @fileoverview Six Step View
 * @version 1.0
 * @author Carlos Emilio Blanco Lopez
 * @date 14/02/2023
 * @copyright 2023 Industrias RESSER S.A de C.V
 */

import React, { useState, useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../hooks/storeHooks";
import { getAutorizeNIP, getActualStep } from "../reducer/slices/DataCotizador";
import { Checkbox } from "@mui/material";
import {
  contentTxt,
  nexBttn,
  disabledBttn,
  sixthStepTitle,
  sixthStepNip,
  AutorizeNIP,
} from "../styles/StepsStyles";
import { InputDefault } from "../components/Inputs/Inputs";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Row } from "antd";
import { getNIP, postNIP, PostRecuperaNIP } from "../apis/ApiNIP";
import { getAnalytics, logEvent } from "@firebase/analytics";
import styles from "../styles/Step.style";
import { message } from 'antd';
import { Fonts } from "../utils/constants";
import ContactMethodModal from "../components/Modals/ContactMethodModal";

const useStyle = styles;

const SixStepView = () => {
  const classes = useStyle()
  const analytics = getAnalytics();
  const [loading, setLoading] = useState(false);
  const [NIP, setNIP] = useState('');
  const [intentCount, setIntentCount] = useState(0);
  const dataCotizacion = useAppSelector((state) => state.DataCotizador);
  const dataResponse = useAppSelector((state) => state.DataResponse);
  const { UserId } = useAppSelector((state) => state.DataResponse);
  const [Autorize, setAutorize] = useState(false);
  const [openContactModal, setOpenContactModal] = useState(false);
  const setActualStep = (value:number) => dispatch(getActualStep(value))
  const dispatch = useAppDispatch();

  useEffect(() => {
    logEvent(analytics, "view_sixth_screen");
  }, []);

  useEffect(() => {

  }, [NIP]);

  const recuperaOption = () => {
    console.log(dataResponse.UserId);

    PostRecuperaNIP(JSON.stringify({
      consultaId: dataResponse.UserId === undefined ? -1 : dataResponse.UserId,
      byEmail: dataCotizacion.byEmail
    }))
      .then((response: any) => {
        if (response === 200) {
          message.destroy();
          message.success({ content: 'NIP fue enviado al correo electronico ingresado', style: { fontFamily: Fonts.sspRegular } });
        }
        else{
          message.destroy();
          message.error({ content: 'Ocurrio un problema al recuperar NIP', style: { fontFamily: Fonts.sspRegular } });
        }
      })
      .catch((error: any) => console.log(error));
  };

  const validateNIP = () => {
    if (!Autorize) {
      validNIP();
      return;
    }
    if (NIP.length !== 4) {
      InvalidNIP();
      return;
    }
    setLoading(true);
    postNIP(dataResponse.UserId === undefined ? -1 : dataResponse.UserId,NIP,dataCotizacion.quoteType)
      .then((response: any) => {
        if(response === 401){
          message.destroy();
          message.error({ content: 'NIP incorrecto', style: { fontFamily: Fonts.sspRegular } });
          setIntentCount(intentCount + 1);
        }else{
          dispatch(getAutorizeNIP());
          dispatch (getActualStep(dataCotizacion.actualStep + 1))
        }
      }).catch((error: any) => {
        message.destroy();
        message.error({ content: 'NIP incorrecto', style: { fontFamily: Fonts.sspRegular } });
      }).finally(() => setLoading(false));
  };

  const InvalidNIP = () => {
    message.destroy();
    message.error({ content: 'Es necesario ingresar un NIP valido', style: { fontFamily: Fonts.sspRegular } });
  }

  const validNIP = () => {
    message.destroy();
    message.error({ content: 'Es necesario seleccionar Autorizo para continuar.', style: { fontFamily: Fonts.sspRegular } });
  }

  const openContactMethodModal = () => {
    setOpenContactModal(true);
  };

  const closeContactMethodModal = () => {
    setOpenContactModal(false);
  };

  return (
    <div className={classes.SixView}>
      <h1
        style={sixthStepTitle}
      >
        Autorización consulta buró de crédito
      </h1>
      <p style={{ ...contentTxt, textAlign: "justify" }}>
        Por este conducto autorizo expresamente a AB&C LEASING DE MÉXICO SAPI DE CV y/o
        FINANCIERA BEPENSA” S.A. DE C.V. SOFOM, E.R., para que por conducto de sus
        funcionarios facultados lleve a cabo investigaciones, sobre mi comportamiento
        crediticio en las sociedades de información crediticia que estime conveniente.
        <br /><br />
        Así mismo, declaro que conozco la naturaleza y alcance de la información que se solicitará,
        del uso que AB&C LEASING DE MÉXICO SAPI DE CV y/o FINANCIERA BEPENSA” S.A. DE C.V. SOFOM,
        E.R., hará de tal información y de que ésta podría realizar consultas periódicas
        de mi historial crediticio, consintiendo que esta autorización se encuentre vigente
        por un período de 3 años a partir de la fecha de su expedición y en todo caso durante
        el tiempo que mantengamos relación jurídica.

      </p>

      <div className={classes.sixthStepAuth}>
        <div className={classes.sixthStepAuthCheckBox}>
          <p
            style={{
              ...contentTxt,
              margin: 0,
            }}
          >
            Autorizo
          </p>
          <Checkbox value={Autorize} onChange={() => setAutorize(!Autorize)} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <InputDefault
            label="NIP"
            onChange={(value: any) => {
              setNIP(value);

            }}
            maxlength={4}
          />
          <a onClick={recuperaOption} style={sixthStepNip}>
            Olvidé mi NIP
          </a>
          <a onClick={openContactMethodModal} style={{ ...sixthStepNip, textAlign: "center" }}>
            Cambiar método de contacto
          </a>
        </div>
      </div>
      <div style={{ margin: 15 }}>
        <Button
          shape='round'
          style={intentCount > 4 ? {...disabledBttn} : {...nexBttn}}
          onClick={validateNIP}
          disabled={loading || intentCount > 4}
          loading={loading}
        >
          Autorizar
        </Button>
      </div>
      {intentCount > 4 && (
        <div>
          <p style={{ ...contentTxt, textAlign: "center" }}>
            ¡Oops! Parece que ha excedido el número máximo de intentos y el botón ha sido bloqueado por seguridad.
            Para continuar, por favor, inicie el proceso de simulación de nuevo.
          </p>
        </div>
      )}
     <ContactMethodModal
        open={openContactModal}
        onClose={closeContactMethodModal}
      />
    </div>

  );
};

export default SixStepView;
